<template>
  <b-container fluid style="padding-left: 0px;padding-right: 0px;">
    <b-table
      hover
      responsive
      select-mode="single"
      small
      :id="id"
      :primary-key="primaryKey"
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :tbody-tr-class="rowClass"      
      sortBy="IDCAB"
      style="min-height: 100px"
    >
      <template v-slot:cell(actions)="row">
        <b-dropdown
          v-if="row.item.STATUS != 'F'"
          id="dropdown-fechado"
          right
          text="Aberto"
          variant="outline-info"
          size="sm"
          style="margin 0;"
        >
          <b-dropdown-item class="editar" @click="onEdit(row.item)">Editar</b-dropdown-item>
          <b-dropdown-item class="fechar" @click="onFecharPedido(row.item)">Fechar</b-dropdown-item>
        </b-dropdown>
        <b-dropdown
          v-if="row.item.STATUS == 'F'"
          id="dropdown-fechado"
          right
          text="Fechado"
          variant="outline-danger"
          size="sm"
          style="margin 0;"
        >
          <b-dropdown-item class="visualizar" @click="onBaixarPDF(row.item)">Visualizar</b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="50"
      aria-controls="my-table"
      align="right"
    >
    </b-pagination>
  </b-container>
</template>

<style>
  .dropdown-menu {
    min-width: 50px!important;
  }
  .editar > a {
    color: #ffc107;
    outline-style: auto;
    margin-bottom: 3px;
  }

  .fechar > a {
    color: #dc3545;
    outline-style: auto;
    margin-bottom: 3px;
  }

  .visualizar > a {
    color: #17a2b8;
    outline-style: auto;
    margin-bottom: 3px;
  }
</style>

<script>
export default {

  name: "PedidoTable",

  props: {
    id: String,

    primaryKey: String,

    items: Array,

    fields: Array,

    onEdit: {
      type: Function,
      default: null,
    },

    onFecharPedido: {
      type: Function,
      default: null,
    },

    onBaixarPDF: {
      type: Function,
      default: null,
    },

    rowClass: Function,
  },

  data() {
    return {
      search: "",
      filter: "",
      currentPage: 1,
      totalRows: 0,
    };
  },

  updated: function() {
    this.totalRows = this.items.length;
  },

  methods: {
    
  },
};
</script>
